import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  QueryList,
  ViewChildren,
  AfterViewInit,
} from '@angular/core';
import { IonInput } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { _findIndex } from '@1bill-app/helpers/lodash.helper';

@Component({
  selector: 'app-confirm-code-input',
  styleUrls: ['./confirm-code-input.component.scss'],
  template: ` <ion-grid>
    <ion-row class="row-code-input ion-justify-content-center">
      <div class="wrapper">
        <ion-row class="ion-justify-content-center">
          <ion-col size="auto" *ngFor="let empty of [].constructor(codeLength); let i = index">
            <ion-input
              class="round"
              [ngClass]="cssClass"
              #codeInput
              [attr.data-cy]="'input-verify-code-'+i"
              type="tel"
              min="0"
              max="9"
              maxlength="1"
              (ionChange)="onInputCode($event.detail.value, i)"
              (keyup)="onKeyUp($event, i)"
              (ionFocus)="onFocus(i)"
              [value]="codeArr[i] ? codeArr[i].toString() : ''"
            ></ion-input>
          </ion-col>
        </ion-row>
      </div>
    </ion-row>
  </ion-grid>`,
})
export class ConfirmCodeInputComponent implements OnInit, AfterViewInit {
  @ViewChildren('codeInput') codeInputRefs: QueryList<IonInput>;
  @Input() codeLength = 4;
  @Input() cssClass = '';
  @Input() autoFocus = true;
  @Input() activeColor = 'rgba(255, 255, 255, 1)';
  @Input() inactiveColor = 'rgba(255, 255, 255, 0.2)';
  @Input() compareWithCode = null;
  @Input() ignoreCase = false;
  @Output() codeFulfilled = new EventEmitter<{ isMatching?: boolean; code: string }>();
  @Output() codeChanged = new EventEmitter<{ code: string }>();
  public codeArr: any[] = [];
  public currentIndex = 0;
  constructor(private logger: NGXLogger) { }

  ngOnInit() {
    this.codeArr = new Array(this.codeLength).fill('');
    if (this.compareWithCode && this.compareWithCode.length !== this.codeLength) {
      this.logger.error('Invalid props: compareWith length is not equal to codeLength');
    }
  }
  ngAfterViewInit() {
    if (this.codeArr.filter((c) => c).length === 0) {
      const refArr = this.codeInputRefs.toArray();
      if (refArr.length > 0) {
        setTimeout(() => {
          this.codeInputRefs.toArray()[0].setFocus();
        }, 400);
      }
    }
  }
  isMatchingCode(code, compareWithCode, ignoreCase = false) {
    if (ignoreCase) {
      return code.toLowerCase() === compareWithCode.toLowerCase();
    }
    return code === compareWithCode;
  }
  clear() {
    this.codeArr = new Array(this.codeLength).fill('');
    this.currentIndex = 0;
    this.setFocus(0);
  }
  async setFocus(index: number) {
    const ionInput = this.codeInputRefs.toArray()[index];
    if (ionInput) {
      ionInput.setFocus();
    }
  }
  async blur(index: number) {
    const ionInput = this.codeInputRefs.toArray()[index];
    if (ionInput) {
      const el = await ionInput.getInputElement();
      return el.blur();
    }
  }
  onFocus(index: number) {
    const newCodeArr = this.codeArr;
    const currentEmptyIndex = _findIndex(newCodeArr, (c) => !c);
    if (currentEmptyIndex !== -1 && currentEmptyIndex <= index) {
      return this.setFocus(currentEmptyIndex);
    }
    [...newCodeArr.keys()].forEach((i) => {
      if (i >= index) {
        newCodeArr[i] = '';
      }
    });

    this.codeArr = newCodeArr;
    this.currentIndex = index;
  }
  onKeyUp(event, index: number) {
    if (event.key === 'Backspace') {
      this.logger.debug({ currentIndex: this.currentIndex });
      const newCodeArr = [...this.codeArr];
      const nextIndex = this.currentIndex > 0 ? this.currentIndex - 1 : 0;
      [...newCodeArr.keys()].forEach((i) => {
        if (i >= nextIndex) {
          newCodeArr[i] = '';
        }
      });
      this.codeChanged.emit({ code: newCodeArr.join('') });
      this.setFocus(nextIndex);
      this.currentIndex = nextIndex;
    }
  }
  onInputCode(value: number, index: number) {
    const newCodeArr = [...this.codeArr];
    newCodeArr[index] = value;
    if (index === this.codeLength - 1) {
      const code = newCodeArr.join('');
      if (this.compareWithCode) {
        const isMatching = this.isMatchingCode(code, this.compareWithCode, this.ignoreCase);
        this.codeFulfilled.emit({ isMatching, code });
        if (!isMatching) {
          this.clear();
        }
      } else {
        this.codeFulfilled.emit({ code });
      }
      this.blur(this.currentIndex);
    } else {
      this.setFocus(this.currentIndex + 1);
    }
    this.codeArr = newCodeArr;
    this.currentIndex = index + 1;
    this.codeChanged.emit({ code: newCodeArr.join('') });
  }
}
